import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import axios from 'axios';

import config from '../../config/enviroment';
import './styles.scss';
import { queryToObj } from '../../utils/query';
import Loading from '../../components/common/loading';
import { translate } from '../../services/translate';
import { handleErrorMessage } from '../../utils/error';

function Title({ requestForm, validToken }) {
    const messageMapping = {
        login: {
            messageH4: translate('LABEL_EXPIREDPASSWORD'),
            messageParagraph: translate('LABEL_ENTERNEWPASSWORD'),
        },
        loginAndAE: {
            messageH4: translate('LABEL_EXPIREDPASSWORD'),
            messageParagraph: translate('LABEL_ENTERNEWPASSWORD'),
        },
        AE: {
            messageH4: translate('LABEL_EXPIREDELECTRONICSIGNATURE'),
            messageParagraph: translate('LABEL_ENTERNEWELETRONICSIGNATURE'),
        },
        firstLogin: {
            messageH4: translate('LABEL_ENTERYOURCREDENTIALS'),
            messageParagraph: translate('LABEL_RESETNEWPASSWORD'),
        },
    };

    if (requestForm.type) {
        return (
            <div className="title">
                <h4>{messageMapping[requestForm.type].messageH4}</h4>
                <p>
                    {validToken
                        ? messageMapping[requestForm.type].messageParagraph
                        : ''}
                </p>
            </div>
        );
    }
    return <></>;
}

export default function ExpiredPassword(props) {
    const [backgroundRandom, setBackgroundRandom] = useState(
        Math.floor(Math.random() * 4 + 1),
    );
    const [loading, setLoading] = useState(false);
    const [loadingPage, setLoadingPage] = useState(false);
    const [apiBadRequestNotif, setApiBadRequestNotif] = useState(false);
    const [validToken, setValidToken] = useState(false);
    const [secondsRedirect, setSecondsRedirect] = useState(false);
    const [validation, setValidation] = useState(false);
    const [apiGoodRequestNotif, setApiGoodRequestNotif] = useState(false);
    const [requestForm, setRequestForm] = useState({
        token: '',
        password: '',
        passwordConfirmation: '',
        digitalSignature: '',
    });
    const passwordChangeTypes = ['login', 'loginAndAE', 'firstLogin'];

    const messageMapping = {
        login: {
            successMessage: translate('TEXT_PASSWORDCHANGED'),
            willRedirected: translate(
                'LABEL_YOUWILLREDIRECTEDTOMAKENEWPASSWORD',
            ),
        },
        loginAndAE: {
            successMessage: translate('TEXT_PASSWORDCHANGED'),
            willRedirected: translate(
                'LABEL_YOUWILLREDIRECTEDTOMAKENEWPASSWORD',
            ),
        },
        AE: {
            successMessage: translate('TEXT_ELECTRONICSIGNATURECHANGED'),
            willRedirected: translate(
                'LABEL_YOUWILLREDIRECTEDTOMAKENEWELECTRONICSIGNATURE',
            ),
        },
        firstLogin: {
            successMessage: translate('TEXT_PASSWORDCHANGED'),
            willRedirected: translate(
                'LABEL_YOUWILLREDIRECTEDTOMAKENEWPASSWORD',
            ),
        },
    };

    const history = useHistory();

    function axiosRequest() {
        setLoading(true);
        axios
            .post(`${config.authURL}expiredpassword`, requestForm)
            .then(_ => {
                setApiBadRequestNotif(false);
                setLoading(false);
                setApiGoodRequestNotif(true);
                setRequestForm(prevState => ({
                    ...prevState,
                    token: '',
                    password: '',
                    passwordConfirmation: '',
                }));
            })
            .catch(err => {
                const { message, additionalData } = handleErrorMessage(
                    err?.response?.data,
                );
                if (
                    err?.response?.data?.message &&
                    err?.response?.data?.additionalData
                ) {
                    setApiBadRequestNotif({
                        message: message,
                        additionalData: additionalData,
                    });
                } else {
                    setApiBadRequestNotif(message);
                }
                setLoading(false);
            });
    }

    function passwordValidation() {
        return {
            validationPassword:
                requestForm.password && requestForm.password.length > 0,
            validationPasswordConfirmation:
                requestForm.password &&
                requestForm.password === requestForm.passwordConfirmation,
            validationDigitalSignature:
                requestForm.digitalSignature &&
                requestForm.digitalSignature.length > 0,
        };
    }

    function onSubmit(e) {
        e.preventDefault();
        setValidation(true);

        const {
            validationPassword,
            validationPasswordConfirmation,
            validationDigitalSignature,
        } = passwordValidation();
        let controlSendRequest = false;

        if (
            passwordChangeTypes.includes(requestForm.type) &&
            validationPassword &&
            validationPasswordConfirmation &&
            validationDigitalSignature
        ) {
            controlSendRequest = true;
        }

        if (
            validationPassword &&
            validationPasswordConfirmation &&
            requestForm.type === 'login'
        ) {
            controlSendRequest = true;
        }

        if (requestForm.type === 'AE' && validationDigitalSignature) {
            controlSendRequest = true;
        }

        if (controlSendRequest) {
            axiosRequest();
            setValidation(false);
            setSecondsRedirect(15);
        }
    }

    useEffect(() => {
        async function loadValidToken() {
            let queryToken;
            if (props.location.search) {
                queryToken = queryToObj(props.location.search).token;
            }

            try {
                setLoadingPage(true);
                const response = await axios.get(
                    `${config.authURL}checktoken/${queryToken}`,
                );
                setLoadingPage(false);
                if (response.data && response.data.validToken) {
                    if (response.data.validToken.firstLogin) {
                        setRequestForm(prevState => ({
                            ...prevState,
                            token: queryToken,
                            type: 'firstLogin',
                        }));
                        setValidToken(true);
                    } else if (
                        response.data.validToken.expiredPassword &&
                        response.data.validToken.expiredDigitalSignature
                    ) {
                        setRequestForm(prevState => ({
                            ...prevState,
                            token: queryToken,
                            type: 'loginAndAE',
                        }));
                        setValidToken(true);
                    } else if (response.data.validToken.expiredPassword) {
                        setRequestForm(prevState => ({
                            ...prevState,
                            token: queryToken,
                            type: 'login',
                        }));
                        setValidToken(true);
                    } else if (
                        response.data.validToken.expiredDigitalSignature
                    ) {
                        setRequestForm(prevState => ({
                            ...prevState,
                            token: queryToken,
                            type: 'AE',
                        }));
                        setValidToken(true);
                    } else {
                        setSecondsRedirect(15);
                    }
                } else {
                    setSecondsRedirect(15);
                }
            } catch (err) {
                setLoadingPage(false);
                setValidToken(true);
                setApiBadRequestNotif(err?.response?.data?.message);
            }
        }

        loadValidToken();
    }, [props.location.search]);

    useEffect(() => {
        if (secondsRedirect > 0)
            setTimeout(() => setSecondsRedirect(secondsRedirect - 1), 1000);

        if (secondsRedirect === 0 && apiGoodRequestNotif) history.push('/');
    }, [secondsRedirect]);

    if (loadingPage) {
        return <Loading width={250} height={250} />;
    }

    return (
        <div className="expiredPassword-body">
            <div
                className="imagesWrapper"
                key={`imagesWrapper-${backgroundRandom}`}>
                <img
                    className="bg-img"
                    src={require(`../../assets/images/background${backgroundRandom}.png`)}
                    alt="background-img"
                />
                <img
                    className="bg-effect"
                    src={require(`../../assets/images/top-right-background-effect.png`)}
                    alt="background-effect"
                />
            </div>
            <div className="loginFormWrapper">
                <img
                    className="form-header-range"
                    src={require('../../assets/images/form-header-range.svg')}
                    alt="form-header-range"
                />
                <div className="loginFormContent">
                    <div className="logo">
                        <img
                            className="logo-neo"
                            src={require('../../assets/images/logo-neo.svg')}
                            alt="Neo"
                        />
                        <img
                            className="text-neo"
                            src={require('../../assets/images/text-neo.svg')}
                            alt="Neo"
                        />
                    </div>
                    {Title({ requestForm, validToken })}
                    {apiBadRequestNotif && (
                        <Alert
                            variant="danger"
                            onClose={() => setApiBadRequestNotif(false)}
                            dismissible>
                            {apiBadRequestNotif?.additionalData ? (
                                <p>
                                    {apiBadRequestNotif?.message}
                                    <ul>
                                        {apiBadRequestNotif.additionalData.map(
                                            a => (
                                                <li key={a.code}>
                                                    {a.code && a.name
                                                        ? `${a.code} - ${a.name}`
                                                        : a.name}
                                                </li>
                                            ),
                                        )}
                                    </ul>
                                </p>
                            ) : (
                                <p>{apiBadRequestNotif}</p>
                            )}
                        </Alert>
                    )}
                    {validToken && !apiGoodRequestNotif ? (
                        <>
                            <Form
                                className="inputs-form"
                                onKeyPress={e =>
                                    e.key === 'Enter' && onSubmit(e)
                                }>
                                {requestForm?.type === 'loginAndAE' ||
                                requestForm?.type === 'firstLogin' ? (
                                    <>
                                        <Form.Group className="input-email">
                                            <Form.Control
                                                required
                                                size="lg"
                                                type="password"
                                                placeholder={translate(
                                                    'LABEL_NEWPASSWORD',
                                                )}
                                                name="password"
                                                value={requestForm.password}
                                                onChange={e => {
                                                    setRequestForm({
                                                        ...requestForm,
                                                        password:
                                                            e.target.value,
                                                    });
                                                    if (
                                                        !apiBadRequestNotif?.additionalData
                                                    ) {
                                                        setApiBadRequestNotif(
                                                            false,
                                                        );
                                                    }
                                                }}
                                                isInvalid={
                                                    validation &&
                                                    !passwordValidation()
                                                        .validationPassword
                                                        ? true
                                                        : false
                                                }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {translate(
                                                    'LABEL_PASSWORDCANNOTEMPTY',
                                                )}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group>
                                            <Form.Control
                                                required
                                                size="lg"
                                                type="password"
                                                placeholder={translate(
                                                    'LABEL_CONFIRMNEWPASSWORD',
                                                )}
                                                name="passwordConfirmation"
                                                value={
                                                    requestForm.passwordConfirmation
                                                }
                                                onChange={e => {
                                                    setRequestForm({
                                                        ...requestForm,
                                                        passwordConfirmation:
                                                            e.target.value,
                                                    });
                                                    if (
                                                        !apiBadRequestNotif?.additionalData
                                                    ) {
                                                        setApiBadRequestNotif(
                                                            false,
                                                        );
                                                    }
                                                }}
                                                isInvalid={
                                                    validation &&
                                                    (!passwordValidation()
                                                        .validationPasswordConfirmation ||
                                                        requestForm.passwordConfirmation ===
                                                            '')
                                                        ? true
                                                        : false
                                                }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {translate(
                                                    'LABEL_PASSWORDDONOTMATCH',
                                                )}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="input-email">
                                            <Form.Control
                                                required
                                                size="lg"
                                                type="password"
                                                placeholder={translate(
                                                    'LABEL_NEWELECTRONICSIGNATURE',
                                                )}
                                                name="digitalSignature"
                                                value={
                                                    requestForm.digitalSignature
                                                }
                                                onChange={e => {
                                                    setRequestForm({
                                                        ...requestForm,
                                                        digitalSignature:
                                                            e.target.value,
                                                    });
                                                    if (
                                                        !apiBadRequestNotif?.additionalData
                                                    ) {
                                                        setApiBadRequestNotif(
                                                            false,
                                                        );
                                                    }
                                                }}
                                                isInvalid={
                                                    validation &&
                                                    (!passwordValidation()
                                                        .validationDigitalSignature ||
                                                        requestForm.digitalSignature ===
                                                            '')
                                                        ? true
                                                        : false
                                                }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {translate(
                                                    'LABEL_ELECTRONICSIGNATURECANNOTBLANK',
                                                )}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </>
                                ) : (
                                    <>
                                        {requestForm?.type == 'login' ? (
                                            <>
                                                <Form.Group className="input-email">
                                                    <Form.Control
                                                        required
                                                        size="lg"
                                                        type="password"
                                                        placeholder={translate(
                                                            'LABEL_NEWPASSWORD',
                                                        )}
                                                        name="password"
                                                        value={
                                                            requestForm.password
                                                        }
                                                        onChange={e => {
                                                            setRequestForm({
                                                                ...requestForm,
                                                                password:
                                                                    e.target
                                                                        .value,
                                                            });
                                                            if (
                                                                !apiBadRequestNotif?.additionalData
                                                            ) {
                                                                setApiBadRequestNotif(
                                                                    false,
                                                                );
                                                            }
                                                        }}
                                                        isInvalid={
                                                            validation &&
                                                            !passwordValidation()
                                                                .validationPassword
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {translate(
                                                            'LABEL_PASSWORDCANNOTEMPTY',
                                                        )}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group>
                                                    <Form.Control
                                                        required
                                                        size="lg"
                                                        type="password"
                                                        placeholder={translate(
                                                            'LABEL_CONFIRMNEWPASSWORD',
                                                        )}
                                                        name="passwordConfirmation"
                                                        value={
                                                            requestForm.passwordConfirmation
                                                        }
                                                        onChange={e => {
                                                            setRequestForm({
                                                                ...requestForm,
                                                                passwordConfirmation:
                                                                    e.target
                                                                        .value,
                                                            });
                                                            if (
                                                                !apiBadRequestNotif?.additionalData
                                                            ) {
                                                                setApiBadRequestNotif(
                                                                    false,
                                                                );
                                                            }
                                                        }}
                                                        isInvalid={
                                                            validation &&
                                                            (!passwordValidation()
                                                                .validationPasswordConfirmation ||
                                                                requestForm.passwordConfirmation ===
                                                                    '')
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {translate(
                                                            'LABEL_PASSWORDDONOTMATCH',
                                                        )}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </>
                                        ) : (
                                            <>
                                                <Form.Group className="input-email">
                                                    <Form.Control
                                                        required
                                                        size="lg"
                                                        type="password"
                                                        placeholder={translate(
                                                            'LABEL_NEWELECTRONICSIGNATURE',
                                                        )}
                                                        name="digitalSignature"
                                                        value={
                                                            requestForm.digitalSignature
                                                        }
                                                        onChange={e => {
                                                            setRequestForm({
                                                                ...requestForm,
                                                                digitalSignature:
                                                                    e.target
                                                                        .value,
                                                            });
                                                            if (
                                                                !apiBadRequestNotif?.additionalData
                                                            ) {
                                                                setApiBadRequestNotif(
                                                                    false,
                                                                );
                                                            }
                                                        }}
                                                        isInvalid={
                                                            validation &&
                                                            (!passwordValidation()
                                                                .validationDigitalSignature ||
                                                                requestForm.digitalSignature ===
                                                                    '')
                                                                ? true
                                                                : false
                                                        }
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {translate(
                                                            'LABEL_ELECTRONICSIGNATURECANNOTBLANK',
                                                        )}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </>
                                        )}
                                    </>
                                )}
                            </Form>
                            <Button
                                className="submit-form"
                                variant={
                                    requestForm.password !== ''
                                        ? 'neoPrimary'
                                        : 'neoSecondary'
                                }
                                disabled={loading ? true : false}
                                onClick={e => onSubmit(e)}>
                                {loading ? (
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                ) : (
                                    <>{translate('LABEL_RESET')}</>
                                )}
                            </Button>
                            <Link to="/" className="forgot-password">
                                {translate('LABEL_RETURNTOLOGIN')}
                            </Link>
                        </>
                    ) : apiGoodRequestNotif ? (
                        <>
                            <Alert
                                variant="success"
                                className="expiredPassword__notif">
                                {requestForm?.type &&
                                    messageMapping[requestForm.type]
                                        .successMessage}
                            </Alert>
                            <p className="expiredPassword__message">
                                {translate('LABEL_REDIRECTEDTOLOGIN')}{' '}
                                {secondsRedirect} {translate('LABEL_SECONDS')}.
                                <br />
                                {translate('LABEL_ORCLICK')}&nbsp;
                                <Link to="/">{translate('LABEL_HERE')}</Link>
                                &nbsp;{translate('LABEL_REDIRECTNOW')}.
                            </p>
                        </>
                    ) : (
                        <>
                            <Alert
                                variant="danger"
                                className="expiredPassword__notif">
                                {translate('LABEL_EXPIREDTOKEN')}
                            </Alert>
                            <p className="expiredPassword__message">
                                <br />
                                {requestForm?.type &&
                                    messageMapping[requestForm.type]
                                        .willRedirected}
                                <br />
                                {translate('LABEL_ORCLICK')}&nbsp;
                                <Link to="/">{translate('LABEL_HERE')}</Link>
                                &nbsp;{translate('LABEL_REDIRECTNOW')}.
                            </p>
                        </>
                    )}
                </div>
                <div className="poweredBy">
                    <a className="by-antares" href="#">
                        powered by
                    </a>
                    <br></br>
                    <img
                        className="logo-antares"
                        src={require('../../assets/images/logo-antares.svg')}
                        alt="Antares vision group"
                    />
                </div>
            </div>
        </div>
    );
}
